//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import NarBar from './component/NavBar.vue'
import Progress from './component/Progress.vue'
import {parseTime} from '../../util/index'
export default {
  components:{
    NarBar,
    Progress
  },
  data(){
    return{
      type_option:[
        { text: '全部' , value: -1, },
        { text: '未开始', value: 0, num:0 },
        { text: '进行中', value: 1, num:0 },
        { text: '已结束', value: 2, num:0 },
      ],
      tabList:[
        { text: '全部工单', value: -1 },
      ],
      tab_id:'',
      status:'',
      search:'',
      orders:{
        orderBy:'',
        sort:'',
      },
      filterData:{
        is_urgent:'',
        is_over_time :'',
        start_time:[],
        end_time:[],
        scheduled_start_time:[],
        scheduled_end_time:[],
        remark:'',
      },
      // 图片路径
      imgUrl:'https://hfb.oss-cn-hangzhou.aliyuncs.com/',
      listData:[],
      loading: false,
      page:1,// 列表页数
      total:'', // 全部个数
      finished: false, // 是否全部加载完成
      refreshing: false, // 加载状态

      // 处理
      show:false,
      activated_id:'',
      priority_type:'',
      status_type:'',

      // 权限
      permissions:false,
    }
  },
  mounted(){
    let role = sessionStorage.getItem('role')
    if(role == 1){  //系统管理员
      this.permissions = true
    }else if(role == 2){  // 管理员
      this.permissions = true
    }else{  // 生产人员
      this.permissions = false
    }
    // 获取tab列表
    // this.$post('/app/Order/getProjectSelect',{config_target: "Order"}).then(res => {
    //   res.forEach(item => {
    //     this.tabList.push({text:item.config_name,value:item.id})
    //   })
    //   // console.log(this.tabList);
    // })
  },
  methods:{
    getTab(){
      this.tabList = [{ text: '全部工单', value: -1 },]
      this.$post('/app/Order/getProjectSelect',{config_target: "Order"}).then(res => {
        res.forEach(item => {
          this.tabList.push({text:item.config_name,value:item.id})
        })
      })
    },
    onLoad() {
        // 异步更新数据
        if (this.refreshing) {
          this.listData = [];
          this.page = 1
          this.refreshing = false;
        }
        let {is_urgent,is_over_time,start_time,end_time,scheduled_start_time,scheduled_end_time,remark} = this.filterData
        let project_id = this.tab_id == -1 ? '' :  this.tab_id 
        let data = {
          page:this.page,
          status:this.status,
          search:this.search,
          orders:this.orders,
          is_urgent,
          is_over_time,
          start_time,
          end_time,
          scheduled_start_time,
          scheduled_end_time,
          remark,
          project_id
        }
        this.$post('/app/Order/getWorkOrderList',data).then(res => {
          this.page++
          this.total = res.total
          this.type_option[1].num = res.is_not_start
          this.type_option[2].num = res.is_start
          this.type_option[3].num = res.is_end

          for (let i = 0; i < res.data.length; i++) {
            res.data[i].scheduled_time = parseTime(res.data[i].scheduled_start_time,'{y}-{m}-{d}') + '~' + parseTime(res.data[i].scheduled_end_time,'{y}-{m}-{d}')
            res.data[i].process_list.forEach((element,index) => {
              element.actual = element.actual * 1
              element.planned = element.planned * 1
              element.step = index + 1
              element.rate = Math.round (element.actual / element.planned * 100) 
            });
            this.listData.push(res.data[i]);
          }

          // 加载状态结束
          this.loading = false;
          // 数据全部加载完成
          if (this.listData.length >= this.total) {
            this.finished = true;
          }

          this.getTab()  // 请求tab
          console.log(this.listData);
        })
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    // 状态切换
    changeType(i){
      if(i == -1){
        this.status = ''
      }else{
        this.status = i
      }
      this.refreshing = true
      this.onRefresh()
    },
    // tab列表切换
    tabChange(value){
      this.tab_id = value
      this.refreshing = true
      this.onRefresh()
    },
    //搜索
    onSearch(value){
      this.search = value
      this.refreshing = true
      this.onRefresh()
    },
    // 排序
    changeOrders(orders){
      console.log(orders);
      this.orders = orders
      this.refreshing = true
      this.onRefresh()
    },
    // 保存筛选
    saveFilterData(filterDate){
      this.filterData.is_urgent = filterDate.is_urgent
      this.filterData.is_over_time = filterDate.is_over_time
      this.filterData.start_time = filterDate.start_time
      this.filterData.end_time = filterDate.end_time
      this.filterData.scheduled_start_time = filterDate.scheduled_start_time
      this.filterData.scheduled_end_time = filterDate.scheduled_end_time
      this.filterData.remark = filterDate.remark
      
      this.refreshing = true
      this.onRefresh()
    },

    // 处理
    onDeal(item) {
      this.activated_id = item.id
      this.priority_type = item.is_urgent
      this.status_type = item.status
      this.show = true
    },
    onDealItem(type,i) {
      if(type == 1){
        this.priority_type = i
      }else if(type == 2){
        this.status_type = i
      }
    },
    onDealSave(){
      let data = {
        add_type:2,
        id:this.activated_id,
        is_urgent:this.priority_type,
        status:this.status_type
      }
      this.$post('/app/Order/setWorkOrder',data).then(res => {
        this.show = false
        this.listData = []
        this.refreshing = true
        this.onRefresh()
        setTimeout(() => {
            this.$toast.success('修改成功!');
        }, 500);
      })
    },

    // 跳转详情
    toDetails(id){
      this.$router.push({
        path:'/OrderDetails',
        query:{id:id}
      })
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/home/one.vue